module.exports = __webpack_public_path__ + "static/breathe-6ffbdd9dd8127724aef59413ade2bfdb.mp4";